import script from "./UpdateFrequency.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateFrequency.vue?vue&type=script&setup=true&lang=js"

import "./UpdateFrequency.vue?vue&type=style&index=0&id=477a4aa0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477a4aa0"]])

export default __exports__